(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/constants.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/constants.js');
'use strict';

const isServer = typeof exports === 'object';
const routes = {
  MY_PROFILE_HOME: '/',
  MY_PROFILE_INFORMATION: '/uppgifter',
  MY_PROFILE_TRANSCRIPT: '/uppgifter/registerutdrag',
  MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE: '/uppgifter/bekrafta-mobil',
  MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE: '/uppgifter/mobil',
  MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL: '/uppgifter/bekrafta-epost',
  MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL: '/uppgifter/saknar-epost',
  MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL: '/uppgifter/epost',
  MY_PROFILE_COMMUNICATION: '/kommunikation',
  MY_PROFILE_COMMUNICATION_ADAPT_CONTENT: '/kommunikation/anpassat-innehall',
  MY_PROFILE_NOTIFICATIONS: '/spelnotifieringar',
  MY_PROFILE_KYC: '/penningtvatt',
  MY_PROFILE_KYC_QUESTIONS: '/penningtvatt/svara',
  MY_PROFILE_KYC_MESSAGES: '/penningtvatt/meddelanden',
  MY_PROFILE_ALIAS: '/uppgifter/alias'
};
const syndicateMailId = {
  SHARE_PURCHASED: 'SvS_marketplace_sharePurchased',
  TERMINATED: 'SvS_marketplace_wagerCancelled',
  DRAW_CREATED: 'SvS_marketplace_activatedDrawCreated',
  WAGER_CREATED: 'SvS_marketplace_wagerCreated',
  REFUNDED: 'SvS_marketplace_shareRefunded',
  BUYIN_CLOSED: 'SvS_marketplace_activatedDrawBuyinClosed',
  NOTIFY_PARTICIPANTS: 'SvS_marketplace_notifyParticipants_o2k',
  NOTIFY_GROUPMEMBER: 'SvS_marketplace_notifyGroupMemberRequested_o2k',
  MARKETPLACE_WAGER: 'SvS_marketplace_wagerCreated_o2k',
  MARKETPLACE_REFUND: 'SvS_marketplace_shareRefunded_o2k',
  MEMBER_ADDED: 'SvS_marketplace_memberAdded',
  MEMBER_REMOVED: 'SvS_marketplace_memberSelfRemoved'
};
const emailStatuses = {
  DELETED: '0',
  BOUNCE: '1',
  VERIFIED: '2',
  OFFERED_VERIFICATION_ACTIVE: '3',
  NOT_OFFERED_VERIFICATION: '4',
  OFFERED_VERIFICATION_EXPIRED: '5'
};
const thunkStatus = {
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
  INITIAL: 'initial'
};
const checkboxNotifcation = {
  TRACK_MAIL: 'trackMail',
  TRACK_LINK: 'trackLink',
  TRACK_WIN: 'trackWin'
};
const titles = {
  ADAPT: 'Anpassat innehåll',
  OFFERS: 'Erbjudanden och annonsering hos samarbetspartners',
  HELP: 'Hjälp oss bli bättre',
  NEWS: 'Nyheter och marknadsföring',
  CORRECT: 'Rättning och påminnelser',
  PLAYTOGETHER: 'Spela tillsammans',
  FRACTIONGAME: 'Andelsspel online',
  APP: 'Notiser via app'
};
const icons = {
  ADAPT: 'customized-content',
  OFFERS: 'nav-sportservice',
  HELP: 'chat-host',
  NEWS: 'news',
  CORRECT: 'win',
  PLAYTOGETHER: 'spela-tillsammans',
  FRACTIONGAME: 'andelsspel',
  APP: 'mobile'
};
const backendName = {
  WIN_RESULTS: 'winResults',
  RECURRING_WAGER_REMINDERS: 'recurringWagerReminders',
  MARKETING_EMAIL: 'marketingEmail',
  MARKETING_SMS: 'marketingSMS',
  MARKETING_LETTER: 'marketingLetter',
  MARKETING_PUSH: 'marketingPush',
  SURVEY_PARTICIPATION: 'surveyParticipation'
};
const productNotificationSetting = {
  productNotificationSetting: [{
    productId: 1,
    productName: 'Stryktipset',
    productValue: 'stryktipset',
    active: true
  }, {
    productId: 2,
    productName: 'Europatipset',
    productValue: 'europatipset',
    active: true
  }, {
    productId: 38,
    productName: 'Fullträff',
    productValue: 'antmal',
    active: true
  }, {
    productId: 25,
    productName: 'Topptipset',
    productValue: 'topptipset',
    active: true
  }, {
    productId: 8,
    productName: 'Måltipset',
    productValue: 'maltipset',
    active: true
  }, {
    productId: 28,
    productName: 'Powerplay',
    productValue: 'powerplay',
    active: true
  }, {
    productId: 33,
    productName: 'Hästar',
    productValue: 'travochgalopp',
    active: true
  }],
  pauseNotificationSetting: {
    paused: false
  }
};
const pausAlternatives = [{
  pauseName: '2 timmar',
  silentMinutes: 120,
  untilMorning: false
}, {
  pauseName: '4 timmar',
  silentMinutes: 240,
  untilMorning: false
}, {
  pauseName: 'Fram till kl 08:00 imorgon.',
  silentMinutes: 0,
  untilMorning: true
}];
const pauseNotifications = {
  unPause: 'unpause notifications',
  pause: 'pause notifications',
  noPause: 'no pause'
};
const exportConstants = {
  routes,
  syndicateMailId,
  emailStatuses,
  thunkStatus,
  checkboxNotifcation,
  titles,
  icons,
  backendName,
  productNotificationSetting,
  pausAlternatives,
  pauseNotifications
};
if (isServer) {
  module.exports = exportConstants;
} else {
  svs.myProfile.constants = exportConstants;
}

 })(window);